import type { InternalAxiosRequestConfig } from 'axios';

export function withMerchantAuthorization(config: InternalAxiosRequestConfig, token: string | null) {
  // Console/preview requests explicitly supply their own scoped credentials.
  // A merchant session from a handoff must not replace those credentials.
  if (token && !config.headers.has('Authorization')) config.headers.set('Authorization', `Bearer ${token}`);
  return config;
}

export function shouldEndMerchantSession(status: number | undefined, config: InternalAxiosRequestConfig | undefined, token: string | null) {
  // A denied operation (403) or missing resource (404) does not invalidate a
  // session. Only an authentication failure for the current merchant token does.
  // Ignore console/preview credentials and responses from a previous session.
  return status === 401 && !!token && config?.headers?.get('Authorization') === `Bearer ${token}`;
}
